'use client'

import { Field, Input, type FieldRootProps, type InputProps } from '@chakra-ui/react'

import React, { forwardRef, type ChangeEventHandler, type ReactEventHandler } from 'react'
import { useDebounceCallback } from 'usehooks-ts'

export type DebounceSearchInputProps = {
	ref: React.Ref<HTMLInputElement>
	label?: string
	callbackFn: (value: string) => void
	placeholder?: string
	errorText?: string
	helperText?: string
	delay?: number
  _field?: FieldRootProps
} & InputProps

export const DebounceSearchInput = forwardRef<HTMLInputElement, DebounceSearchInputProps>(
	(prop, ref) => {
	const {
		label,
		callbackFn,
		placeholder,
		errorText,
		helperText,
		delay = 1000,
		...props
	} = prop
	const  debounceCallback = useDebounceCallback(callbackFn, delay)

	return (
		<Field.Root w={props.w}>
			<Field.Label>{label}</Field.Label>
			<Input
				ref={ref}
				placeholder={placeholder}
				onChange={(e) => debounceCallback(e.target.value)}
        {...props}
			/>
			{helperText && <Field.HelperText>{helperText}</Field.HelperText>}
			{errorText && <Field.ErrorText>{errorText}</Field.ErrorText>}
		</Field.Root>
		)
	} 
)